import React, { ChangeEvent, useState, ChangeEventHandler } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Row, Col, Image, Form, Button } from "react-bootstrap";
import Input from "../../components/Form/Input";
import Logo1 from "../../assets/images/logo1.png";
import ImageSrc from "../../assets/images/Group_252.png";
import useWindowDimensions from "../../helpers/GetCurrentWidth";
import Alert from "../../helpers/Alert";
import { sendPasswordResetToken } from "../../services/UserService";
import PublicBackground from "../../components/PublicBackground";
import Password from "../../assets/images/password.svg"

import "./index.css";
import "./recover.css"

export default function ForgotPassword() {
  let history = useNavigate();

  const [email, setEmail] = useState<string>("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { width } = useWindowDimensions();

  const handleSubmit = (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    sendPasswordResetToken(email)
      .then((res) => {
        setShowConfirmation(true)
        setTimeout(() => {
          history("/login")
        }, 5000)
      })
      .catch((err) => {
        Alert(false, err.response.data.error);
      });
  };
  return (
    <PublicBackground>
      {showConfirmation ? (
        <div className="loading-recover--content-wrapper">
          <img className="loading-recover--image-content" src={Password} alt="" />
          <div className="loading-recover--content-container">
            <div className="loading-recover--content-description">
              Foi enviado um email com link para recuperação de senha.
            </div>
          </div>
        </div>
      ) : (
          <>
            <div className="recover-title">Recuperar Senha</div>
            <div className="recover--form-container">
              <Form onSubmit={handleSubmit} className="recover-form">
                <Input
                  className="signup-input"
                  name="email"
                  label="E-mail"
                  type="email"
                  placeholder={"email@email.com"}
                  data={email}
                  setData={(event: ChangeEvent<HTMLInputElement>) => {
                    setEmail(event.target.value);
                  }}
                  required={true}
                />
                <button type="submit" className="recover-button">
                  recuperar
              </button>
                <div className="l-inline-center">
                  <NavLink to="/login" className="recover-signup">
                    Ja tenho uma conta
                </NavLink>
                </div>
              </Form>
            </div>
          </>
        )}
    </PublicBackground>
  );
}
